import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getAnalyticsUser } from '../../selectors/analytics';
import { EAvailableBrokerFlow } from '../../repositories/newbuilding-search/entities/newbuilding_broker/NewbuildingBrokerSchema';
import { IBrokerAnalyticsUser } from '../../types/broker';

export const useBrokerAnalyticsUser = (brokerFlow: EAvailableBrokerFlow) => {
  const user = useSelector(getAnalyticsUser);

  return useMemo<IBrokerAnalyticsUser>(
    () => ({
      ...user,
      extra: {
        is_individual: brokerFlow === EAvailableBrokerFlow.WithPartnerRewards,
      },
    }),
    [user, brokerFlow],
  );
};
